import { yupResolver } from "@hookform/resolvers/yup";
import { CSpinner } from "@coreui/react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { useCookie } from "../../hooks/useCookie";
import { useToast } from "../../hooks/useToast";
import { general } from "../../locales/general";
import { createPromoCodeSchema, createPromoDto } from "../../rules/promo";
import apiService from "../../service/apiService";
import { cardStyle } from "../Places/PlacesTable";
import CreatePromoCode from "./CreatePromoCode";

export default function AddNewPromoCode() {
  const { control, handleSubmit, watch, setError, setValue } = useForm<
    yup.InferType<typeof createPromoCodeSchema>
  >({
    resolver: yupResolver(createPromoCodeSchema),
    defaultValues: {
      scope: "GLOBAL",
    },
  });

  const navigate = useNavigate();
  const { toastError } = useToast();
  const { token } = useCookie("vToken");

  const maxUsage = watch("maxUses");

  const createPromoCodeMutation = useMutation({
    mutationFn: (data: createPromoDto) =>
      apiService.MakePostRequest("promo-codes", data, token),
  });

  const onSubmit = async (data: createPromoDto) => {
    try {
      const { event, offer, place, scope, items, ...rest } = data;

      const payload: any = {
        ...rest,
        scope,
      };

      if (scope === "EVENT") {
        payload.eventId = event?.id;
        payload.items =
          items?.map((item) => ({
            serviceId: item.serviceId,
            maxUses: item.maxUses,
          })) || [];
      }

      if (scope === "SPECIALS") {
        payload.offerId = offer?.id;
      }

      if (scope === "PLACE") {
        payload.placeId = place?.id;
      }

      if (scope === "EVENT") {
        const totalServiceUsage =
          payload.items?.reduce(
            (sum: number, item: any) => sum + (item.maxUses || 0),
            0,
          ) || 0;

        if (totalServiceUsage > payload.maxUses) {
          return setError(`items.${payload.items.length - 1}.maxUses`, {
            message: `L'utilisation totale (${totalServiceUsage}) dépasse (${payload.maxUses})`,
          });
        }
      }

      await createPromoCodeMutation.mutateAsync(payload);
      navigate(-1);
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        general.fr.message.operationFailed;

      toastError(message);
      console.error("Promo code error:", error);
    }
  };

  const isLoading = createPromoCodeMutation.isLoading;

  return (
    <div className="vz-form px-2 mt-4">
      {/* Header */}
      <div
        style={{ ...cardStyle, padding: "16px 20px" }}
        className="d-flex justify-content-between align-items-center mb-3"
      >
        <div>
          <h4 className="fs-4 fw-bold mb-0">Ajouter un nouveau code promo</h4>
          <div className="text-muted" style={{ fontSize: 13 }}>
            Les champs marqués d'une * sont obligatoires
          </div>
        </div>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="btn btn-outline-secondary rounded-pill px-3"
        >
          ← Retour
        </button>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <section style={cardStyle} className="mb-3">
          <CreatePromoCode
            control={control}
            watch={watch}
            setValue={setValue}
            maxUsage={maxUsage}
          />
        </section>

        {/* Sticky actions */}
        <div
          className="d-flex justify-content-end gap-2 py-3 px-3 mt-3"
          style={{
            position: "sticky",
            bottom: 0,
            zIndex: 5,
            backgroundColor: "#fff",
            borderRadius: 16,
            boxShadow: "0 -4px 16px rgba(0,0,0,0.06)",
          }}
        >
          <button
            type="button"
            disabled={isLoading}
            onClick={() => navigate(-1)}
            className="btn btn-outline-secondary rounded-pill px-4"
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="btn btn-success text-white rounded-pill px-4"
          >
            {isLoading ? <CSpinner size="sm" /> : "Enregistrer"}
          </button>
        </div>
      </form>
    </div>
  );
}
